// extracted by mini-css-extract-plugin
module.exports = {"listItemText":"AttributesSlide_listItemText__c1_DO","listItem":"AttributesSlide_listItem__m2WFI"};